import { render, staticRenderFns } from "./ImportTable.vue?vue&type=template&id=4efd9ef6&scoped=true"
import script from "./ImportTable.vue?vue&type=script&lang=js"
export * from "./ImportTable.vue?vue&type=script&lang=js"
import style0 from "./ImportTable.vue?vue&type=style&index=0&id=4efd9ef6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efd9ef6",
  null
  
)

export default component.exports